import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import cn from 'classnames';

import Button from 'components/form/Button.component';
import SidebarMenu from 'components/menu/SidebarMenu.component';
import CurrencySign from 'components/price/CurrencySign.component';
import LINK from 'constants/link.const';
import THEME_MODE from 'constants/themeMode.const';
import { withTranslation } from 'providers/GILT.provider';
import { selectCashupIsFetching, selectCashupPriceList } from 'selectors/cashup.selectors';
import { selectCurrentSalonCalendarMode, selectCurrentSalonId, selectCurrentSalonName } from 'selectors/currentSalon.selectors';
import { selectOnboardingServicesCategories } from 'selectors/onboarding.selectors';
import { selectCognitoAttributeName, xeLogoutUser } from 'utils/cognito.util';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';
import linkTo from 'utils/links/linkTo.util';
import asObject from 'utils/objects/asObject.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';

import { getServicePriceList } from 'cashup/actions';
import PadLock from 'lib/components/PadLock';
import { getCategories } from 'onboarding/services/actions';

import 'styles/common/user-dropdown.scss';

class ServicePriceList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      priceList: null,
      menuVisible: false,
    };
    this.componentRef = React.createRef();
  }

  componentDidMount() {
    const { getCategories, getServicePriceList, salonId } = this.props;
    getServicePriceList(salonId);
    getCategories(salonId);
    window.scrollTo(0, 0);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.priceList !== this.state.priceList) {
      this.setState({ priceList: nextProps.priceList });
    }
  }

  onLogOutClick = () => void this.props.xeLogoutUser();

  openMenu = () => void this.setState({ menuVisible: !this.state.menuVisible });

  // eslint-disable-next-line consistent-return
  makePriceList = () => {
    const { priceList } = this.props;

    const categoriesAll = [];
    const priceListObj = {};

    if (priceList && priceList.length) {
      for (let i = 0; i < priceList.length; i += 1) {
        if (!priceList[i].stylists.length) {
          priceList.splice(i, 1);
          // if the first two don't have stylists, [creative, senior], after deleting the first, i becomes 1
          // it will start to check from the 2nd item, miss the first one 'senior' which
          // now is the first item and can only be deleted by index i = 0
          // so to avoid that, we need to put i back
          i -= 1;
        }
      }
    }

    if (priceList && priceList.length) {
      for (let i = 0; i < priceList.length; i += 1) {
        if (priceList[i].stylists.length) {
          categoriesAll.push(...priceList[i].services.map((s) => s.category && s.category.name));
        }
      }

      // order categories by orders in onboarding
      const orderedCategories = this.props.categories;
      const categoriesNoOrder = [...new Set(categoriesAll)];
      const categories = [];

      for (let i = 0; i < orderedCategories.length; i += 1) {
        const found = categoriesNoOrder.filter((e) => e === orderedCategories[i].name);
        if (found.length) {
          categories.push(found[0]);
        }
      }

      for (let l = 0; l < categories.length; l += 1) {
        const category = categories[l];
        priceListObj[category] = {};
        let services = [];
        const serviceWithRole = [];

        for (let i = 0; i < priceList.length; i += 1) {
          const role = priceList[i].name;
          services = priceList[i].services.filter((s) => s.category.name === category);
          for (const s of services) {
            s.roleName = role;
          }
          for (let j = 0; j < services.length; j += 1) {
            // eslint-disable-next-line no-loop-func
            const serArr = serviceWithRole.filter((s) => s.service === services[j].name);
            if (serArr.length === 0) {
              serviceWithRole.push({
                service: services[j].name,
                price: { [services[j].roleName]: services[j].price },
              });
            } else {
              for (let k = 0; k < serviceWithRole.length; k += 1) {
                if (serviceWithRole[k].service === services[j].name) {
                  serviceWithRole[k].price[services[j].roleName] = services[j].price;
                }
              }
            }
          }
          if (!priceListObj[category].services) {
            priceListObj[category].services = serviceWithRole;
          }
        }
      }

      return [priceListObj, categories];
    }
  };

  render() {
    const { menuVisible } = this.state;

    const t = this.props.t;
    const { priceList, isFetching, salonId, userData, calendarMode } = this.props;

    const [priceListObj, categories] = isFullArray(priceList) ? this.makePriceList() : [];

    const rollNumber = priceList ? priceList.filter((role) => role.stylists && role.stylists.length) : [];

    const size = rollNumber.length;
    const roleNameList = [];
    if (priceList && priceList.length > 0) {
      priceList.filter((role) => role.stylists && role.stylists.length).map((role) => roleNameList.push(role.name));
    }

    const componentClasses = cn({
      'salon settings': true,
      'light-class': calendarMode === THEME_MODE.light,
      'dark-class': calendarMode === THEME_MODE.dark,
      'bright-class': calendarMode !== THEME_MODE.light && calendarMode !== THEME_MODE.dark,
    });

    return (
      <div data-bem="ServicePriceList" className={componentClasses}>
        <header className="settings-header stock-global-nav">
          <SidebarMenu />
          <div className="global-nav">
            <div className="page-name text-mobile price-list" />
            <nav className="menu-list">
              <ul className="ul-scroll-menu" />
            </nav>
          </div>
          <div className="user-logins in-price-list-page" onClick={() => this.openMenu()} role="button" tabIndex="0" style={{ zIndex: '3' }}>
            <span className="user-name">{userData.name}</span>
            <span className="arrow--down" />
            {menuVisible && (
              <div className="dropdown user-dropdown">
                <div className="dropdown-menu">
                  <div onClick={this.onLogOutClick} role="button" tabIndex="0" className="list-item">
                    {t('servicePriceList.logoutButton')}
                  </div>

                  <NavLink to={`/salon/${salonId}/settings/user_profile`} activeClassName="active" className="list-item">
                    {t('servicePriceList.userProfileButton')}
                  </NavLink>
                </div>
              </div>
            )}
          </div>
          <PadLock inMenu />
        </header>

        {size !== 0 ? (
          <div className="price-list--container">
            <div className="price-list--options">
              <ReactToPrint
                trigger={() => (
                  <Button variant="primary" casing="dialog">
                    {t('servicePriceList.printListTitle')}
                  </Button>
                )}
                content={() => this.componentRef.current}
              />
              <div className="price-list--title">{t('servicePriceList.note')}</div>
              {t('servicePriceList.editMessage')}
              <NavLink
                to={linkTo({
                  pattern: LINK.services,
                  params: { salonId },
                  fault: '#',
                })}
                activeClassName="active"
                className="link"
              >
                {t('servicePriceList.settingsLink')}
              </NavLink>
            </div>
            <div className="price-list--wrap" ref={this.componentRef}>
              <table id="price-list--table">
                <tr className="price-list--header">
                  <td className="first-column">{t('servicePriceList.services')}</td>
                  {priceList &&
                    priceList
                      .filter((role) => role.stylists && role.stylists.length)
                      .map((role) => (
                        <td key={role.id} className="td-width">
                          <h2>{role.name}</h2>
                          <small>
                            {role.stylists.map((stylistName) => (
                              <div className="stylist" key={stylistName}>
                                {stylistName}
                              </div>
                            ))}
                          </small>
                        </td>
                      ))}
                </tr>

                {categories &&
                  categories.map((category) => (
                    <>
                      <tr key={category}>
                        <td colSpan={size + 1} className="price-list">
                          <h3 className="category-title">{category}</h3>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={size + 1}>
                          <table>
                            {priceListObj &&
                              priceListObj[category] &&
                              priceListObj[category].services.map((service) => (
                                <tr key={service.service}>
                                  <td colSpan={size + 1} className="td-border">
                                    <table className="table-services-list">
                                      <tr>
                                        <td className="td-width">
                                          <div className="td-width">{service.service}</div>
                                        </td>
                                        {roleNameList.map((roleName) =>
                                          roleName in service.price ? (
                                            <td className="td-width">
                                              <div className="td-width">
                                                <CurrencySign value={service.price[roleName]} />
                                              </div>
                                            </td>
                                          ) : (
                                            <td className="td-width">
                                              <div className="td-width" />
                                            </td>
                                          ),
                                        )}
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              ))}
                          </table>
                        </td>
                      </tr>
                    </>
                  ))}
              </table>
            </div>
          </div>
        ) : (
          <div className="empty-list">
            <div>{t('servicePriceList.noStylists')}</div>
          </div>
        )}

        {isFetching && <div className="load-blocker" />}
      </div>
    );
  }
}

const ServicePriceListHoc = connect(
  (state) => ({
    ...asObject(selectCashupPriceList(state)), // FIXME: shouldn't use spread here, priceList is already a separate field
    //
    salonId: selectCurrentSalonId(state),
    salonName: selectCurrentSalonName(state),
    calendarMode: selectCurrentSalonCalendarMode(state),
    //
    priceList: selectCashupPriceList(state),
    isFetching: selectCashupIsFetching(state),
    //
    categories: selectOnboardingServicesCategories(state),
    //
    cognitoName: selectCognitoAttributeName(state),
    userData: {
      // FIXME: remove this extra object and use the above cognitoName in its place
      name: selectCognitoAttributeName(state),
    },
  }),
  mapActionsToDispatchToProps({
    getServicePriceList,
    getCategories,
    xeLogoutUser,
  }),
)(withTranslation()(ServicePriceList));

export default ServicePriceListHoc;
